import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from './modules/components/typography';
import Button from './modules/components/button';

export function SectionHeading({ eyebrow, title, subtitle, align = 'center' }) {
  return (
    <Stack spacing={2} sx={{ mb: 6, maxWidth: 760, mx: align === 'center' ? 'auto' : 0 }}>
      {eyebrow && (
        <Typography variant="body2" sx={{ textTransform: 'uppercase', letterSpacing: 1.3, opacity: 0.8 }}>
          {eyebrow}
        </Typography>
      )}
      <Typography variant="h4" align={align} marked={align === 'center' ? 'center' : undefined}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="subtitle1" align={align}>
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
}

export function SectionCTA({ title, subtitle, ctaLabel, ctaProps }) {
  return (
    <Box
      sx={{
        mt: 6,
        px: 4,
        py: 4,
        borderRadius: 3,
        background: 'linear-gradient(135deg, rgba(77,161,255,0.18), rgba(99,210,179,0.16))',
        textAlign: 'center'
      }}
    >
      <Typography variant="h5" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {subtitle}
      </Typography>
      <Button color="secondary" variant="contained" size="large" {...ctaProps}>
        {ctaLabel}
      </Button>
    </Box>
  );
}
